import React from 'react';
import { Phone, AlertTriangle, Wrench, Droplet, CheckCircle } from 'lucide-react';
export function RollUpDoorServicePage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-4462">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-4463">
        <div className="container mx-auto px-4" data-id="element-4464">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center italic" data-id="element-4465">
            Roll-up doors
          </h1>
          <p className="text-xl text-gray-100 text-center font-bold italic" data-id="element-4466">
            Watch'em they're behind you all the way!!
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-4467">
        <div className="max-w-4xl mx-auto" data-id="element-4468">
          {/* Hero Image */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8 text-center" data-id="element-4469">
            <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/truck%20pictures/watchmetruck.gif" alt="Roll-up door truck" className="mx-auto mb-6 max-w-full h-auto" data-id="element-4470" />
          </div>

          {/* Safety Warning */}
          <div className="bg-red-50 border-2 border-red-500 rounded-lg shadow-md p-8 mb-8" data-id="element-4471">
            <div className="flex items-start" data-id="element-4472">
              <AlertTriangle className="text-red-600 mr-4 flex-shrink-0 mt-1" size={32} data-id="element-4473" />
              <div data-id="element-4474">
                <h2 className="text-2xl font-bold text-red-900 mb-4" data-id="element-4475">
                  Important Safety Information
                </h2>
                <p className="text-lg text-gray-800" data-id="element-4476">
                  An overhead door is a large, heavy object that moves with the
                  help of a spring that is under high tension. Since moving
                  objects and springs under tension can cause injuries or death,
                  your safety and the proper operation of the door depend on
                  you.
                </p>
              </div>
            </div>
          </div>

          {/* Door Maintenance Tip */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4477">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-4478">
              <Droplet className="mr-3 text-blue-600" size={32} data-id="element-4479" />
              Door Maintenance Tip
            </h2>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-6" data-id="element-4480">
              <p className="text-lg text-gray-700 mb-4" data-id="element-4481">
                <strong data-id="element-4482">
                  Lubricate the counterbalance, bearings, rollers, hinges with
                  Lube. Do not use grease.
                </strong>
              </p>
              <p className="text-gray-700" data-id="element-4483">
                Wipe dirt from track. Frequency of door maintenance will vary
                with climate conditions and door cleaning procedures.
              </p>
            </div>

            <div className="space-y-3" data-id="element-4484">
              <div className="flex items-start" data-id="element-4485">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4486" />
                <p className="text-gray-700" data-id="element-4487">
                  Doors which are steam cleaned will need lubricating more often
                </p>
              </div>

              <div className="flex items-start" data-id="element-4488">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4489" />
                <p className="text-gray-700" data-id="element-4490">
                  Doors on equipment which is run in areas where road salts are
                  used will require lock lubrication at closer intervals
                </p>
              </div>

              <div className="flex items-start" data-id="element-4491">
                <AlertTriangle className="text-yellow-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4492" />
                <p className="text-gray-700" data-id="element-4493">
                  <strong data-id="element-4494">Note:</strong> Do not use any petroleum-based
                  lubricant on rubber door seals
                </p>
              </div>
            </div>
          </div>

          {/* Roll-up Door Operator */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4495">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center italic" data-id="element-4496">
              This is typical roll-up door operator
            </h2>

            <div className="text-center mb-8" data-id="element-4497">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/Door%20Stuff/counterbalance_full.jpg?opt=w3" alt="Roll-up door counterbalance" className="mx-auto rounded-lg shadow-sm" style={{
              width: '300px',
              height: 'auto'
            }} data-id="element-4498" />
            </div>
          </div>

          {/* Lubrication Points */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4499">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-4500">
              Inside view: arrows pointing to lube points
            </h2>

            <div className="bg-yellow-50 border-2 border-yellow-500 rounded-lg p-6 mb-6 text-center" data-id="element-4501">
              <p className="text-xl font-bold text-gray-900 italic" data-id="element-4502">
                Should be lubricated once every two weeks
              </p>
            </div>

            <div className="text-center mb-8" data-id="element-4503">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/Door%20Stuff/lubpoints.gif" alt="Lubrication points diagram" className="mx-auto rounded-lg shadow-sm" data-id="element-4504" />
            </div>

            <div className="bg-blue-50 rounded-lg p-6" data-id="element-4505">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-4506">
                Door Maintenance Tips
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-4507">
                One of the quickest and easiest ways to prolong the life of your
                overhead doors is to keep the counterbalance springs lubricated.
                The spring is a moving part that winds and unwinds, so
                lubrication makes its operation easier. It also helps prevent
                rust, which can inhibit movement.
              </p>
              <p className="text-gray-700 font-semibold" data-id="element-4508">
                Spend just five minutes lubricating the springs on your doors
                every month, and you'll add years to their service life.
              </p>
            </div>
          </div>

          {/* Repair Services */}
          <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white rounded-lg shadow-xl p-8 mb-8 text-center" data-id="element-4509">
            <h2 className="text-3xl font-bold mb-4 flex items-center justify-center" data-id="element-4510">
              <Wrench className="mr-3" size={32} data-id="element-4511" />
              Professional Roll-up Door Repair
            </h2>
            <p className="text-xl mb-4" data-id="element-4512">
              Garrett Auto & Truck performs repairs on all make and models of
              Roll-up doors.
            </p>
            <p className="text-lg mb-4" data-id="element-4513">
              From One roller to a complete door assembly.
            </p>
            <div className="bg-white text-[#B1050B] rounded-lg p-4 inline-block" data-id="element-4514">
              <p className="text-3xl font-bold" data-id="element-4515">Starting at just $599.00</p>
            </div>
          </div>

          {/* Lift Cables Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4516">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-4517">
              We almost forgot to mention the lift cables...
            </h2>

            <div className="bg-green-50 border-l-4 border-green-500 p-6 mb-6" data-id="element-4518">
              <p className="text-lg text-gray-700" data-id="element-4519">
                A properly counterbalanced door should, when stopped, remain at
                any given location. If the door has a tendency to drop when
                stopped, a few more quarter turns should be added, or the door
                may be in need of repair.
              </p>
            </div>

            <div className="text-center mb-6" data-id="element-4520">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/Door%20Stuff/Cables_duo.jpg?opt=w3" alt="Lift cables" className="mx-auto rounded-lg shadow-sm" data-id="element-4521" />
            </div>

            <div className="bg-red-50 border-2 border-red-500 rounded-lg p-6" data-id="element-4522">
              <div className="flex items-start" data-id="element-4523">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/Misc%20gifs/Caution.gif" alt="Caution" className="mr-4 flex-shrink-0" data-id="element-4524" />
                <div data-id="element-4525">
                  <h3 className="text-xl font-bold text-red-900 mb-3" data-id="element-4526">
                    Safety Tip:
                  </h3>
                  <p className="text-lg text-gray-800" data-id="element-4527">
                    <strong data-id="element-4528">
                      Watch for fraying of the cables; cables must have even
                      tension at all times. If not severe injury may occur.
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Service Summary */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4529">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-4530">
              Complete Roll-up Door Services
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-4531">
              <div className="text-center" data-id="element-4532">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-4533">
                  <Wrench className="text-blue-600" size={32} data-id="element-4534" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-4535">
                  Repairs
                </h3>
                <p className="text-gray-700" data-id="element-4536">
                  All makes and models, from single roller to complete assembly
                </p>
              </div>

              <div className="text-center" data-id="element-4537">
                <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-4538">
                  <Droplet className="text-green-600" size={32} data-id="element-4539" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-4540">
                  Maintenance
                </h3>
                <p className="text-gray-700" data-id="element-4541">
                  Lubrication, inspection, and preventative care
                </p>
              </div>

              <div className="text-center" data-id="element-4542">
                <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-4543">
                  <CheckCircle className="text-purple-600" size={32} data-id="element-4544" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-4545">
                  Safety Inspections
                </h3>
                <p className="text-gray-700" data-id="element-4546">
                  Cable tension, counterbalance, and safety checks
                </p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-4547">
            <h2 className="text-3xl font-bold mb-4" data-id="element-4548">
              Expert Roll-up Door Service & Repair
            </h2>
            <p className="text-xl mb-6" data-id="element-4549">
              Professional service for all makes and models
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-4550">
              <Phone className="mr-3" size={24} data-id="element-4551" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-4552">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}